import styled from 'styled-components';
import { styleguide } from '../../../theme/styleguide';

export const DivDescribe = styled.div`
  width: 312px;
  height: 144px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto 9px;

  @media (min-width: ${styleguide.breakpoints.tablet}) {
    width: 198px;
    height: 216px;
  }
`;

export const DivTitle = styled.div`
  width: 312px;
  height: 48px;

  @media (min-width: ${styleguide.breakpoints.tablet}) {
    border-bottom: solid 1px ${styleguide.colors.gray[300]};
    width: 198px;
    height: 78px;
  }
`;

export const Title = styled.h2`
  font-family: 'Inter';
  align-self: flex-start;
  line-height: 24px;
  letter-spacing: -0.2px;
  font-weight: 700;
  font-size: 20px;
  color: #000000;
`;

export const DivDescribeTitle = styled.div`
  display: flex;
  width: 312px;
  margin-bottom: 24px;
  gap: 8px;

  @media (min-width: ${styleguide.breakpoints.tablet}) {
    width: 198px;
    height: 216px;
  }
`;

export const DescribeTitle = styled.p`
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  font-weight: 400;
  color: #666666;
  margin-bottom: 0;
`;
